import React, { useState, useEffect } from 'react';

const BASE_URL = 'https://api.app.pixventa.com';

function ConfigVariantes() {
  const [grupos,      setGrupos]      = useState([]);
  const [cargando,    setCargando]    = useState(true);
  const [addingGrupo, setAddingGrupo] = useState(false);
  const [nuevoGrupo,  setNuevoGrupo]  = useState('');
  const [tipoGrupo,   setTipoGrupo]   = useState('texto');
  const [addingHija,  setAddingHija]  = useState(null);
  const [nuevaOpcion, setNuevaOpcion] = useState('');
  const [nuevaHex,    setNuevaHex]    = useState('#ff9a9e');
  const [abiertos,    setAbiertos]    = useState({});

  useEffect(() => { cargar(); }, []);

  async function cargar() {
    setCargando(true);
    const res  = await fetch(`${BASE_URL}/variante-grupos`);
    const data = await res.json();
    setGrupos(data);
    const ab = {};
    data.forEach(g => ab[g.id] = true);
    setAbiertos(ab);
    setCargando(false);
  }

  function toggleGrupo(id) {
    setAbiertos(prev => ({ ...prev, [id]: !prev[id] }));
  }

  async function crearGrupo() {
    if (!nuevoGrupo.trim()) return;
    const existe = grupos.find(g => g.nombre.toLowerCase() === nuevoGrupo.trim().toLowerCase());
    if (existe) { alert(`⚠️ Ya existe "${nuevoGrupo}"`); return; }

    const res  = await fetch(`${BASE_URL}/variante-grupos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ nombre: nuevoGrupo.trim(), tipo: tipoGrupo }),
    });
    const nuevo = await res.json();

    // Actualiza estado local sin recargar
    setGrupos(prev => [...prev, { ...nuevo, opciones: [] }]);
    setAbiertos(prev => ({ ...prev, [nuevo.id]: true }));
    setNuevoGrupo('');
    setTipoGrupo('texto');
    setAddingGrupo(false);
  }

  async function eliminarGrupo(g) {
    if (!window.confirm(`¿Eliminar "${g.nombre}" y todas sus opciones?`)) return;
    await fetch(`${BASE_URL}/variante-grupos/${g.id}`, { method: 'DELETE' });
    // Actualiza estado local sin recargar
    setGrupos(prev => prev.filter(x => x.id !== g.id));
  }

  async function agregarOpcion(grupo) {
    if (!nuevaOpcion.trim()) return;

    if (grupo.tipo === 'color') {
      const existe = grupo.opciones.find(o => o.nombre.toLowerCase() === nuevaOpcion.trim().toLowerCase());
      if (existe) { alert(`⚠️ "${nuevaOpcion}" ya existe`); return; }

      const res = await fetch(`${BASE_URL}/variante-opciones`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ grupo_id: grupo.id, nombre: nuevaOpcion.trim(), hex: nuevaHex }),
      });
      const nueva = await res.json();

      // Actualiza estado local sin recargar
      setGrupos(prev => prev.map(g =>
        g.id === grupo.id ? { ...g, opciones: [...g.opciones, nueva] } : g
      ));
    } else {
      const vals  = nuevaOpcion.split(',').map(t => t.trim()).filter(Boolean);
      const dups  = vals.filter(v => grupo.opciones.find(o => o.nombre.toLowerCase() === v.toLowerCase()));
      const nuevas = vals.filter(v => !grupo.opciones.find(o => o.nombre.toLowerCase() === v.toLowerCase()));

      if (dups.length > 0) alert(`⚠️ Ya existen: ${dups.join(', ')}`);
      if (nuevas.length === 0) { setNuevaOpcion(''); setAddingHija(null); return; }

      const agregadas = [];
      for (const n of nuevas) {
        const res = await fetch(`${BASE_URL}/variante-opciones`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ grupo_id: grupo.id, nombre: n }),
        });
        agregadas.push(await res.json());
      }

      // Actualiza estado local sin recargar
      setGrupos(prev => prev.map(g =>
        g.id === grupo.id ? { ...g, opciones: [...g.opciones, ...agregadas] } : g
      ));
    }

    setNuevaOpcion('');
    setNuevaHex('#ff9a9e');
    setAddingHija(null);
  }

  async function eliminarOpcion(opcion, grupo) {
    if (!window.confirm(`¿Eliminar "${opcion.nombre}" de ${grupo.nombre}?`)) return;
    await fetch(`${BASE_URL}/variante-opciones/${opcion.id}`, { method: 'DELETE' });
    // Actualiza estado local sin recargar
    setGrupos(prev => prev.map(g =>
      g.id === grupo.id ? { ...g, opciones: g.opciones.filter(o => o.id !== opcion.id) } : g
    ));
  }

  if (cargando) return <div style={styles.loading}>Cargando variantes...</div>;

  return (
    <div style={styles.container}>

      <div style={styles.infoBox}>
        <span style={{ fontSize: 18 }}>💡</span>
        <div style={styles.infoText}>Crea grupos de variantes y agrega sus opciones. Al crear un producto seleccionas cuáles aplican.</div>
      </div>

      <div style={styles.secTitle}>Grupos de variantes</div>

      {grupos.map(g => (
        <div key={g.id} style={styles.grupo}>
          <div style={styles.grupoHeader} onClick={() => toggleGrupo(g.id)}>
            <span style={styles.grupoIcon}>{g.tipo === 'color' ? '🎨' : '🏷️'}</span>
            <span style={styles.grupoNombre}>{g.nombre}</span>
            <span style={styles.grupoCount}>{g.opciones.length} opciones</span>
            <button style={styles.deleteBtn} onClick={e => { e.stopPropagation(); eliminarGrupo(g); }}>🗑</button>
            <span style={{ color:'#7A8F89', fontSize:12, display:'inline-block', transition:'transform .2s', transform: abiertos[g.id] ? 'rotate(180deg)' : 'none' }}>▼</span>
          </div>

          {abiertos[g.id] && (
            <div style={styles.hijasWrap}>
              <div style={styles.chips}>
                {g.opciones.map(o => (
                  <div key={o.id} style={{ ...styles.chip, ...(g.tipo === 'color' ? styles.chipColor : styles.chipTexto) }}>
                    {g.tipo === 'color' && (
                      <span style={{ width:10, height:10, borderRadius:'50%', background:o.hex, display:'inline-block', border:'1px solid rgba(0,0,0,.1)', flexShrink:0 }} />
                    )}
                    {o.nombre}
                    <button style={styles.chipDel} onClick={() => eliminarOpcion(o, g)}>✕</button>
                  </div>
                ))}
              </div>

              {addingHija === g.id ? (
                <div style={styles.addHijaRow}>
                  {g.tipo === 'color' && (
                    <input type="color" style={styles.colorPicker} value={nuevaHex} onChange={e => setNuevaHex(e.target.value)} />
                  )}
                  <input
                    style={styles.hijaInput}
                    placeholder={g.tipo === 'color' ? 'Nombre del color' : 'Ej. XL, 28 (separar con comas)'}
                    value={nuevaOpcion}
                    onChange={e => setNuevaOpcion(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && agregarOpcion(g)}
                    autoFocus
                  />
                  <button style={styles.confirmBtn} onClick={() => agregarOpcion(g)}>✓</button>
                  <button style={styles.cancelBtn} onClick={() => { setAddingHija(null); setNuevaOpcion(''); }}>✕</button>
                </div>
              ) : (
                <button style={styles.addHijaBtn} onClick={() => setAddingHija(g.id)}>
                  ＋ Agregar opción
                </button>
              )}
            </div>
          )}
        </div>
      ))}

      {addingGrupo ? (
        <div style={styles.addGrupoCard}>
          <div style={styles.addGrupoHeader}>
            <span style={{ fontSize: 20 }}>🏷️</span>
            <input
              style={styles.grupoInput}
              placeholder="Nombre del grupo (ej. Material, Talla calzado...)"
              value={nuevoGrupo}
              onChange={e => setNuevoGrupo(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && crearGrupo()}
              autoFocus
            />
            <button style={styles.confirmBtn} onClick={crearGrupo}>✓</button>
            <button style={styles.cancelBtn} onClick={() => setAddingGrupo(false)}>✕</button>
          </div>
          <div style={styles.tipoRow}>
            <button style={{ ...styles.tipoBtn, ...(tipoGrupo === 'texto' ? styles.tipoBtnSel : {}) }} onClick={() => setTipoGrupo('texto')}>📝 Texto</button>
            <button style={{ ...styles.tipoBtn, ...(tipoGrupo === 'color' ? styles.tipoBtnSel : {}) }} onClick={() => setTipoGrupo('color')}>🎨 Color</button>
          </div>
        </div>
      ) : (
        <button style={styles.openAddBtn} onClick={() => setAddingGrupo(true)}>
          <span style={{ fontSize: 18 }}>＋</span> Agregar grupo de variantes
        </button>
      )}

    </div>
  );
}

const styles = {
  container:     { padding: 16, paddingBottom: 90 },
  loading:       { padding: 40, textAlign: 'center', color: '#7A8F89' },
  infoBox:       { background: '#f0fff5', border: '1px solid #c8e6c9', borderRadius: 12, padding: '12px 14px', display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 16 },
  infoText:      { fontSize: 12, color: '#2e7d32', lineHeight: 1.5 },
  secTitle:      { fontSize: 13, fontWeight: 700, color: '#7A8F89', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 10 },
  grupo:         { background: 'white', borderRadius: 16, border: '1px solid #E4EDE8', overflow: 'hidden', marginBottom: 12, boxShadow: '0 2px 8px rgba(0,0,0,.05)' },
  grupoHeader:   { display: 'flex', alignItems: 'center', gap: 10, padding: '13px 14px', background: 'linear-gradient(to right,#f0fff5,#f8fcf9)', borderBottom: '1px solid #E4EDE8', cursor: 'pointer' },
  grupoIcon:     { fontSize: 20 },
  grupoNombre:   { flex: 1, fontFamily: 'inherit', fontSize: 14, fontWeight: 700, color: '#0D1F1A' },
  grupoCount:    { fontSize: 11, color: '#7A8F89', background: '#F0F4F0', padding: '2px 8px', borderRadius: 20 },
  deleteBtn:     { width: 28, height: 28, background: 'none', border: 'none', color: '#7A8F89', cursor: 'pointer', borderRadius: 8, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  hijasWrap:     { padding: '12px 14px 4px' },
  chips:         { display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 },
  chip:          { borderRadius: 20, padding: '6px 10px 6px 14px', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6, border: '1.5px solid' },
  chipColor:     { background: '#f0fff5', color: '#128C7E', borderColor: '#c8e6c9' },
  chipTexto:     { background: '#f5f5f5', color: '#444', borderColor: '#ddd' },
  chipDel:       { width: 16, height: 16, background: '#FF4757', color: 'white', border: 'none', borderRadius: '50%', fontSize: 9, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0 },
  addHijaRow:    { display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 },
  colorPicker:   { width: 34, height: 34, borderRadius: 8, border: '1.5px solid #E4EDE8', cursor: 'pointer', padding: 2, flexShrink: 0 },
  hijaInput:     { flex: 1, background: '#F0F4F0', border: '1.5px solid #E4EDE8', borderRadius: 10, padding: '7px 12px', fontSize: 13, color: '#0D1F1A', outline: 'none', fontFamily: 'inherit' },
  confirmBtn:    { width: 32, height: 32, background: '#25D366', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15, fontWeight: 700, flexShrink: 0 },
  cancelBtn:     { width: 32, height: 32, background: '#F0F4F0', color: '#7A8F89', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, flexShrink: 0 },
  addHijaBtn:    { background: 'none', border: 'none', color: '#128C7E', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', padding: '4px 0 10px', display: 'flex', alignItems: 'center', gap: 4 },
  addGrupoCard:  { background: 'white', borderRadius: 16, border: '2px dashed #E4EDE8', overflow: 'hidden', marginBottom: 12 },
  addGrupoHeader:{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 14px' },
  grupoInput:    { flex: 1, background: '#F0F4F0', border: '1.5px solid #E4EDE8', borderRadius: 10, padding: '9px 12px', fontSize: 14, color: '#0D1F1A', outline: 'none', fontFamily: 'inherit', fontWeight: 600 },
  tipoRow:       { display: 'flex', gap: 8, padding: '0 14px 12px' },
  tipoBtn:       { flex: 1, padding: '8px', border: '1.5px solid #E4EDE8', borderRadius: 10, fontSize: 12, fontWeight: 600, cursor: 'pointer', background: 'white', fontFamily: 'inherit', color: '#7A8F89' },
  tipoBtnSel:    { borderColor: '#25D366', background: '#f0fff5', color: '#128C7E' },
  openAddBtn:    { width: '100%', background: 'none', border: 'none', padding: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, color: '#128C7E', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' },
};

export default ConfigVariantes;